import { createContext, useContext, type ReactNode } from "react";

// Slot pattern: embedded tab pages can register page-level actions into the shell's
// tab bar row via this context, so actions render inline with the tabs (not floating
// in their own awkward strip below).
export type InsightsActionsSlotContextValue = {
  setActions: (node: ReactNode) => void;
};

export const InsightsActionsSlotContext = createContext<InsightsActionsSlotContextValue>({
  setActions: () => {},
});

export const useInsightsActionsSlot = () => useContext(InsightsActionsSlotContext);
